module.exports = __webpack_public_path__ + "static/gallery10-3f5f7bb97c861cb673a55cf79a5263a0.jpg";